import React from 'react';
import PropTypes from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';

import makeStyles from '@material-ui/styles/makeStyles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete'; 

import PreferenceExpandedItem from './preference-expanded-item';

const useStyles = makeStyles(() => ({
  summary: {
    textAlign: 'center'
  }
}));

const PreferenceListItem = (props) => {
  const classes = useStyles();

  const itemSummary = () => {
    const summaryList = [{txt: props.type, width: 10}, {txt: props.instance, width: 15}, 
      {txt: props.id, width: 15}, {txt: props.updated_ts, width: 30}];
    return (
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
        {
          summaryList.map(({ txt, width}, idx) => {
            return (
              <Typography key={idx} style={{ flexBasis: `${width}%` }}>{txt}</Typography>
            )
          })
        }
        <div style={{ flexBasis: '30%', textAlign: 'center' }}>
          <IconButton onClick={e => {
            props.handleEditPreference(props.idx);
            e.stopPropagation();
          }}>
            <EditIcon />
          </IconButton>
          <IconButton onClick={e => {
            props.handleRemovePreference(props.type, props.instance, props.id);
            e.stopPropagation();
          }}>
            <DeleteIcon />
          </IconButton>
        </div>
      </ExpansionPanelSummary>
    );
  };

  const itemDetails = () => {
    return (     
      <ExpansionPanelDetails>
        <PreferenceExpandedItem attributes={props.attributes} />
      </ExpansionPanelDetails>
    );
  };
  return (
    <ExpansionPanel>
      {itemSummary()}
      {itemDetails()}
    </ExpansionPanel>
  )
};

PreferenceListItem.propTypes = {
  idx: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  instance: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  updated_ts: PropTypes.string.isRequired,
  attributes: PropTypes.array.isRequired,
  handleEditPreference: PropTypes.func.isRequired,
  handleRemovePreference: PropTypes.func.isRequired
};

export default React.memo(PreferenceListItem);
